import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { computed } from 'mobx'
import { withStyles } from 'material-ui/styles'
import withAppStore from 'decorators/withAppStore'
import authorized from 'decorators/authorized'

import LoadingPage from 'components/LoadingPage'
import NoKeys from 'components/NoKeys'
import KeysList from 'components/KeysList'

import getApiKeys from 'tasks/getApiKeys'

import styles from 'styles/pages/keys'

@withStyles(styles)
@authorized
@withAppStore
@observer
export default class Keys extends Component {

  @computed
  get keys() {
    return getApiKeys.result
  }

  componentWillMount() {
    this.appStore.pageTitle = 'Мои ключи'
    getApiKeys.perform()
  }

  render() {
    const { classes } = this.props

    return (
      <div className={ classes.root } >
        { this.keys && this.keys.length ? (
          <KeysList keys={ this.keys.toJS() } />
        ) : getApiKeys.isRunning ? (
          <LoadingPage visible />
        ) : (
          <NoKeys />
        )}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/keys.js